module.exports = __webpack_public_path__ + "img/loading.45b7f6cd.svg";